import { ticketDashboardTableConfig } from "../../containers/ticketing/ticketDashboard/ticketDashboardHelper";
import { viewChildTicketTableConfig } from "../../containers/ticketing/viewTicket/viewTicketHelper";
import {
  categoryDetailsTableConfig,
  categoryDetailsTableActionConfig
} from "../../containers/ticketing/categorySettings/categoryDetails/categoryDetailsHelper";

export const zoomTableActionsConfig = {
  // Each object is a button. Give it a classname else default will be picked up
  TICKET_DASHBOARD_KEY: {},
  VIEW_CHILD_TICKET_KEY: {},
  CATEGORY_DETAILS_KEY: categoryDetailsTableActionConfig
};

// The place to sort out all your tables
// Syntax to follow - RouteModule_TabModule
export const zoomTableConfig = {
  TICKET_DASHBOARD_KEY: ticketDashboardTableConfig,
  VIEW_CHILD_TICKET_KEY: viewChildTicketTableConfig,
  CATEGORY_DETAILS_KEY: categoryDetailsTableConfig
};



// WEBPACK FOOTER //
// ./app/components/commons/zoomTable/zoomTableConfig.js